// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container and Layout */
.MaterialVendorDetails-container {
  max-width: 1200px;
  margin: 0 auto;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f8fafc;
  min-height: 100vh;
}

/* Header */
.MaterialVendorDetails-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 20px 0;
  border-bottom: 2px solid #e2e8f0;
}

.MaterialVendorDetails-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a202c;
  margin: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.MaterialVendorDetails-badge {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.9rem;
  box-shadow: 0 4px 6px rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
}

.MaterialVendorDetails-badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(102, 126, 234, 0.4);
}

/* Controls Section */
.MaterialVendorDetails-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  gap: 20px;
  flex-wrap: wrap;
}

/* Search Bar */
.MaterialVendorDetails-search-container {
  position: relative;
  flex: 1 1;
  max-width: 500px;
}

.MaterialVendorDetails-search-input {
  width: 100%;
  padding: 12px 45px 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 25px;
  font-size: 1rem;
  background: white;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.MaterialVendorDetails-search-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.MaterialVendorDetails-search-icon {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #64748b;
  font-size: 1.2rem;
}

.MaterialVendorDetails-results-count {
  background: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.9rem;
  color: #667eea;
  border: 2px solid #e2e8f0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Loading State */
.MaterialVendorDetails-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: #64748b;
}

.MaterialVendorDetails-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Table Styles */
.MaterialVendorDetails-table-container {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05), 0 10px 15px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
}

.MaterialVendorDetails-table {
  width: 100%;
  border-collapse: collapse;
}

.MaterialVendorDetails-table-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.MaterialVendorDetails-table-header th {
  padding: 16px 12px;
  text-align: left;
  font-weight: 600;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.MaterialVendorDetails-table-body {
  background: white;
}

.MaterialVendorDetails-table-row {
  border-bottom: 1px solid #e5e7eb;
  transition: background-color 0.2s ease;
}

.MaterialVendorDetails-table-row:hover {
  background: #f8fafc;
}

.MaterialVendorDetails-table-cell {
  padding: 12px;
  font-size: 0.9rem;
  color: #374151;
  vertical-align: middle;
}

.MaterialVendorDetails-bill-cell {
  font-weight: 600;
  color: #667eea;
}

.MaterialVendorDetails-material-cell {
  font-weight: 600;
  color: #1f2937;
}

.MaterialVendorDetails-quantity-cell {
  color: rgb(0, 0, 0);
  font-weight: 600;
  border-radius: 8px;
  text-align: center;
}

.MaterialVendorDetails-table-link-btn {
  background: none;
  border: none;
  color: #3b82f6;
  cursor: pointer;
  text-decoration: underline;
  font-size: 0.9rem;
  padding: 0;
  transition: color 0.2s ease;
}

.MaterialVendorDetails-table-link-btn:hover {
  color: #1d4ed8;
}

.MaterialVendorDetails-table-image-btn {
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.MaterialVendorDetails-table-image-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(139, 92, 246, 0.3);
}

.MaterialVendorDetails-table-action-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.MaterialVendorDetails-table-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.3);
}

/* Action Buttons */
.MaterialVendorDetails-action-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
}

.MaterialVendorDetails-edit-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  border: none;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);
}

.MaterialVendorDetails-edit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.4);
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
}

.MaterialVendorDetails-delete-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  border: none;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);
}

.MaterialVendorDetails-delete-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(239, 68, 68, 0.4);
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
}

/* Modal Styles */
.MaterialVendorDetails-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-in-out;
}

.MaterialVendorDetails-image-modal {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.3);
}

.MaterialVendorDetails-modal-image {
  width: 100%;
  height: auto;
  max-height: 90vh;
  object-fit: contain;
}

.MaterialVendorDetails-details-modal {
  background: white;
  border-radius: 16px;
  max-width: 500px;
  width: 90vw;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.3);
}

.MaterialVendorDetails-modal-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.MaterialVendorDetails-modal-title {
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0;
}

.MaterialVendorDetails-modal-close {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.MaterialVendorDetails-modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.MaterialVendorDetails-modal-content {
  padding: 24px;
}

.MaterialVendorDetails-modal-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.MaterialVendorDetails-modal-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.MaterialVendorDetails-modal-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.MaterialVendorDetails-modal-value {
  font-size: 1rem;
  color: #1f2937;
  font-weight: 500;
  padding: 10px 14px;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

/* Delete Modal Styles */
.MaterialVendorDetails-delete-modal {
  background: white;
  border-radius: 16px;
  max-width: 450px;
  width: 90vw;
  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.3s ease-out;
}

.MaterialVendorDetails-delete-modal-header {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 16px 16px 0 0;
}

.MaterialVendorDetails-delete-modal-title {
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0;
}

.MaterialVendorDetails-delete-modal-content {
  padding: 24px;
  text-align: center;
}

.MaterialVendorDetails-delete-modal-icon {
  font-size: 3rem;
  margin-bottom: 16px;
}

.MaterialVendorDetails-delete-modal-text {
  font-size: 1.1rem;
  color: #374151;
  margin-bottom: 16px;
  font-weight: 500;
}

.MaterialVendorDetails-delete-modal-details {
  background: #f9fafb;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 24px;
  text-align: left;
  border: 1px solid #e5e7eb;
  font-size: 0.9rem;
  color: #6b7280;
  line-height: 1.6;
}

.MaterialVendorDetails-delete-modal-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.MaterialVendorDetails-delete-cancel-btn {
  background: #f3f4f6;
  color: #374151;
  border: 2px solid #e5e7eb;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.MaterialVendorDetails-delete-cancel-btn:hover {
  background: #e5e7eb;
  border-color: #d1d5db;
}

.MaterialVendorDetails-delete-confirm-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);
}

.MaterialVendorDetails-delete-confirm-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(239, 68, 68, 0.4);
}

.MaterialVendorDetails-delete-confirm-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Form Modal Styles */
.MaterialVendorDetails-form-modal {
  background: white;
  border-radius: 16px;
  max-width: 800px;
  width: 95vw;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.3s ease-out;
  scrollbar-width: none;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.MaterialVendorDetails-form-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.MaterialVendorDetails-form-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

.MaterialVendorDetails-form-content {
  padding: 24px;
}

.MaterialVendorDetails-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.MaterialVendorDetails-form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.MaterialVendorDetails-form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.MaterialVendorDetails-form-group-full {
  grid-column: 1 / -1;
}

.MaterialVendorDetails-form-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
}

.MaterialVendorDetails-form-input {
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  background: white;
  transition: all 0.3s ease;
  font-family: inherit;
}

.MaterialVendorDetails-form-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.MaterialVendorDetails-form-input:invalid {
  border: 1px solid #ccc;
}

.MaterialVendorDetails-form-textarea {
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  background: white;
  transition: all 0.3s ease;
  font-family: inherit;
  resize: vertical;
  min-height: 80px;
}

.MaterialVendorDetails-form-textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.MaterialVendorDetails-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.MaterialVendorDetails-form-cancel-btn {
  background: #f3f4f6;
  color: #374151;
  border: 2px solid #e5e7eb;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.MaterialVendorDetails-form-cancel-btn:hover {
  background: #e5e7eb;
  border-color: #d1d5db;
}

.MaterialVendorDetails-form-submit-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.3);
}

.MaterialVendorDetails-form-submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.4);
}

.MaterialVendorDetails-form-submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.MaterialVendorDetails-form-error {
  background: #fee2e2;
  color: #dc2626;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #fecaca;
  margin-bottom: 16px;
  font-size: 0.9rem;
  font-weight: 500;
}

/* No Data State */
.MaterialVendorDetails-noData {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.MaterialVendorDetails-noData-icon {
  font-size: 4rem;
  margin-bottom: 16px;
}

.MaterialVendorDetails-noData h3 {
  font-size: 1.5rem;
  color: #374151;
  margin: 0 0 8px 0;
}

.MaterialVendorDetails-noData p {
  color: #6b7280;
  font-size: 1rem;
  margin: 0 0 20px 0;
}

.MaterialVendorDetails-clear-search-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.3);
}

.MaterialVendorDetails-clear-search-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.4);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Print Info */
.MaterialVendorDetails-printInfo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 16px;
}

/* Existing Image Preview Styles */
.MaterialVendorDetails-existing-image {
  margin-bottom: 16px;
  padding: 16px;
  background: #f8fafc;
  border: 2px dashed #e2e8f0;
  border-radius: 8px;
}

.MaterialVendorDetails-existing-image-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.MaterialVendorDetails-existing-image-preview {
  max-width: 200px;
  max-height: 150px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid #e5e7eb;
}

.MaterialVendorDetails-existing-image-preview:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.MaterialVendorDetails-existing-image-note {
  font-size: 0.8rem;
  color: #6b7280;
  margin-top: 8px;
  font-style: italic;
}

.MaterialVendorDetails-new-file-selected {
  font-size: 0.9rem;
  color: #059669;
  font-weight: 500;
  margin-top: 8px;
  padding: 8px 12px;
  background: #ecfdf5;
  border-radius: 6px;
  border: 1px solid #a7f3d0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .MaterialVendorDetails-container {
    padding: 16px;
  }

  .MaterialVendorDetails-title {
    font-size: 2rem;
  }

  .MaterialVendorDetails-header {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }

  .MaterialVendorDetails-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .MaterialVendorDetails-search-container {
    max-width: none;
  }

  .MaterialVendorDetails-table-container {
    overflow-x: auto;
  }

  .MaterialVendorDetails-table {
    min-width: 800px;
  }

  .MaterialVendorDetails-form-modal {
    width: 98vw;
    margin: 10px;
  }

  .MaterialVendorDetails-form-grid {
    grid-template-columns: 1fr;
  }

  .MaterialVendorDetails-form-actions {
    flex-direction: column;
  }

  .MaterialVendorDetails-details-modal {
    width: 95vw;
    margin: 20px;
  }

  .MaterialVendorDetails-action-buttons {
    flex-direction: column;
    gap: 4px;
  }

  .MaterialVendorDetails-delete-modal-actions {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .MaterialVendorDetails-container {
    padding: 12px;
  }

  .MaterialVendorDetails-title {
    font-size: 1.75rem;
  }

  .MaterialVendorDetails-form-content {
    padding: 16px;
  }

  .MaterialVendorDetails-form-header {
    padding: 16px;
  }

  .MaterialVendorDetails-modal-content {
    padding: 16px;
  }

  .MaterialVendorDetails-modal-header {
    padding: 16px;
  }
}

/* Print Styles */
@media print {
  .MaterialVendorDetails-container {
    background: white;
    box-shadow: none;
  }

  .MaterialVendorDetails-controls,
  .MaterialVendorDetails-badge {
    display: none;
  }

  .MaterialVendorDetails-table-container {
    box-shadow: none;
    border: 1px solid #ccc;
  }

  .MaterialVendorDetails-table-action-btn,
  .MaterialVendorDetails-table-image-btn,
  .MaterialVendorDetails-action-buttons {
    display: none;
  }

  .MaterialVendorDetails-table-cell {
    white-space: nowrap;
  }
}

/* add transaction */
/* Demo Container */
.transaction-demo-container {
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

/* Trigger Button */
.MaterialVendorDetails_addtransaction-trigger-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.3);
}

.MaterialVendorDetails_addtransaction-trigger-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.4);
}

/* Modal Overlay */
.MaterialVendorDetails_addtransaction-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-in-out;
  padding: 20px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Modal Container */
.MaterialVendorDetails_addtransaction-modal {
  background: white;
  border-radius: 16px;
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Modal Header */
.MaterialVendorDetails_addtransaction-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 16px 16px 0 0;
}

.MaterialVendorDetails_addtransaction-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

.MaterialVendorDetails_addtransaction-close-btn {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.MaterialVendorDetails_addtransaction-close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.MaterialVendorDetails_addtransaction-close-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Modal Content */
.MaterialVendorDetails_addtransaction-content {
  padding: 24px;
}

/* Error Message */
.MaterialVendorDetails_addtransaction-error {
  background: #fee2e2;
  color: #dc2626;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #fecaca;
  margin-bottom: 20px;
  font-size: 0.9rem;
  font-weight: 500;
}

/* Form Styles */
.MaterialVendorDetails_addtransaction-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.MaterialVendorDetails_addtransaction-form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.MaterialVendorDetails_addtransaction-form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.MaterialVendorDetails_addtransaction-form-group-full {
  grid-column: 1 / -1;
}

.MaterialVendorDetails_addtransaction-form-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
}

.MaterialVendorDetails_addtransaction-form-input,
.MaterialVendorDetails_addtransaction-form-select {
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  background: white;
  transition: all 0.3s ease;
  font-family: inherit;
}

.MaterialVendorDetails_addtransaction-form-input:focus,
.MaterialVendorDetails_addtransaction-form-select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.MaterialVendorDetails_addtransaction-form-input:disabled,
.MaterialVendorDetails_addtransaction-form-select:disabled {
  background-color: #f9fafb;
  cursor: not-allowed;
  opacity: 0.7;
}

.MaterialVendorDetails_addtransaction-form-select {
  cursor: pointer;
}

.MaterialVendorDetails_addtransaction-form-textarea {
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  background: white;
  transition: all 0.3s ease;
  font-family: inherit;
  resize: vertical;
  min-height: 80px;
}

.MaterialVendorDetails_addtransaction-form-textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.MaterialVendorDetails_addtransaction-form-textarea:disabled {
  background-color: #f9fafb;
  cursor: not-allowed;
  opacity: 0.7;
}

/* Form Actions */
.MaterialVendorDetails_addtransaction-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.MaterialVendorDetails_addtransaction-cancel-btn {
  background: #f3f4f6;
  color: #374151;
  border: 2px solid #e5e7eb;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.MaterialVendorDetails_addtransaction-cancel-btn:hover {
  background: #e5e7eb;
  border-color: #d1d5db;
}

.MaterialVendorDetails_addtransaction-cancel-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.MaterialVendorDetails_addtransaction-submit-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.3);
}

.MaterialVendorDetails_addtransaction-submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.4);
}

.MaterialVendorDetails_addtransaction-submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Responsive Design */
@media (max-width: 768px) {
  .MaterialVendorDetails_addtransaction-overlay {
    padding: 10px;
  }

  .MaterialVendorDetails_addtransaction-modal {
    max-width: 100%;
    margin: 0;
  }

  .MaterialVendorDetails_addtransaction-header {
    padding: 20px;
  }

  .MaterialVendorDetails_addtransaction-title {
    font-size: 1.3rem;
  }

  .MaterialVendorDetails_addtransaction-content {
    padding: 20px;
  }

  .MaterialVendorDetails_addtransaction-form-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .MaterialVendorDetails_addtransaction-form-actions {
    flex-direction: column;
    gap: 8px;
  }

  .MaterialVendorDetails_addtransaction-cancel-btn,
  .MaterialVendorDetails_addtransaction-submit-btn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .MaterialVendorDetails_addtransaction-overlay {
    padding: 5px;
  }

  .MaterialVendorDetails_addtransaction-header {
    padding: 16px;
  }

  .MaterialVendorDetails_addtransaction-title {
    font-size: 1.2rem;
  }

  .MaterialVendorDetails_addtransaction-content {
    padding: 16px;
  }

  .MaterialVendorDetails_addtransaction-form-input,
  .MaterialVendorDetails_addtransaction-form-select,
  .MaterialVendorDetails_addtransaction-form-textarea {
    font-size: 16px; /* Prevents zoom on iOS */
  }
}

@media (max-width: 360px) {
  .MaterialVendorDetails_addtransaction-form-grid {
    gap: 12px;
  }

  .MaterialVendorDetails_addtransaction-form-label {
    font-size: 0.85rem;
  }

  .MaterialVendorDetails_addtransaction-cancel-btn,
  .MaterialVendorDetails_addtransaction-submit-btn {
    padding: 10px 20px;
    font-size: 0.9rem;
  }
}

/* High DPI Displays */
@media (min-resolution: 192dpi) {
  .MaterialVendorDetails_addtransaction-form-input,
  .MaterialVendorDetails_addtransaction-form-select,
  .MaterialVendorDetails_addtransaction-form-textarea {
    border-width: 1px;
  }
}

/* Dark Mode Support (if needed) */
@media (prefers-color-scheme: dark) {
  .MaterialVendorDetails_addtransaction-modal {
    background: #1f2937;
    color: #f9fafb;
  }

  .MaterialVendorDetails_addtransaction-form-input,
  .MaterialVendorDetails_addtransaction-form-select,
  .MaterialVendorDetails_addtransaction-form-textarea {
    background: #374151;
    border-color: #4b5563;
    color: #f9fafb;
  }

  .MaterialVendorDetails_addtransaction-error {
    background: #7f1d1d;
    color: #fca5a5;
    border-color: #991b1b;
  }
}

/* Print Styles */
@media print {
  .MaterialVendorDetails_addtransaction-overlay {
    display: none;
  }
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  .MaterialVendorDetails_addtransaction-overlay,
  .MaterialVendorDetails_addtransaction-modal,
  .MaterialVendorDetails_addtransaction-close-btn,
  .MaterialVendorDetails_addtransaction-submit-btn,
  .MaterialVendorDetails_addtransaction-cancel-btn {
    animation: none;
    transition: none;
  }
}

/* Focus Styles for Accessibility */
.MaterialVendorDetails_addtransaction-close-btn:focus,
.MaterialVendorDetails_addtransaction-cancel-btn:focus,
.MaterialVendorDetails_addtransaction-submit-btn:focus {
  outline: 2px solid #667eea;
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Material/MaterialVendorDetails.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,cAAc;EACd,4DAA4D;EAC5D,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yEAAyE;EACzE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,6DAA6D;AAC/D;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,oBAAoB;AACpB,mBAAmB;AACnB;EACE,aAAa;EACb,4DAA4D;AAC9D;;AAEA,mBAAmB;AACnB;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,iBAAiB;AACjB;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,eAAe,EAAE,yBAAyB;EAC5C;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA,sBAAsB;AACtB;EACE;;;IAGE,iBAAiB;EACnB;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;;;IAGE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,qBAAqB;EACvB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;EACf;AACF;;AAEA,kBAAkB;AAClB;EACE;;;;;IAKE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,mCAAmC;AACnC;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":["/* Container and Layout */\n.MaterialVendorDetails-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n  background-color: #f8fafc;\n  min-height: 100vh;\n}\n\n/* Header */\n.MaterialVendorDetails-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding: 20px 0;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.MaterialVendorDetails-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #1a202c;\n  margin: 0;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.MaterialVendorDetails-badge {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-weight: 600;\n  font-size: 0.9rem;\n  box-shadow: 0 4px 6px rgba(102, 126, 234, 0.3);\n  transition: all 0.3s ease;\n}\n\n.MaterialVendorDetails-badge:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(102, 126, 234, 0.4);\n}\n\n/* Controls Section */\n.MaterialVendorDetails-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n/* Search Bar */\n.MaterialVendorDetails-search-container {\n  position: relative;\n  flex: 1;\n  max-width: 500px;\n}\n\n.MaterialVendorDetails-search-input {\n  width: 100%;\n  padding: 12px 45px 12px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 25px;\n  font-size: 1rem;\n  background: white;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.MaterialVendorDetails-search-input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.MaterialVendorDetails-search-icon {\n  position: absolute;\n  right: 15px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #64748b;\n  font-size: 1.2rem;\n}\n\n.MaterialVendorDetails-results-count {\n  background: white;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: #667eea;\n  border: 2px solid #e2e8f0;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Loading State */\n.MaterialVendorDetails-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 300px;\n  color: #64748b;\n}\n\n.MaterialVendorDetails-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #e2e8f0;\n  border-top: 4px solid #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Table Styles */\n.MaterialVendorDetails-table-container {\n  background: white;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05), 0 10px 15px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n}\n\n.MaterialVendorDetails-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.MaterialVendorDetails-table-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.MaterialVendorDetails-table-header th {\n  padding: 16px 12px;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.MaterialVendorDetails-table-body {\n  background: white;\n}\n\n.MaterialVendorDetails-table-row {\n  border-bottom: 1px solid #e5e7eb;\n  transition: background-color 0.2s ease;\n}\n\n.MaterialVendorDetails-table-row:hover {\n  background: #f8fafc;\n}\n\n.MaterialVendorDetails-table-cell {\n  padding: 12px;\n  font-size: 0.9rem;\n  color: #374151;\n  vertical-align: middle;\n}\n\n.MaterialVendorDetails-bill-cell {\n  font-weight: 600;\n  color: #667eea;\n}\n\n.MaterialVendorDetails-material-cell {\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.MaterialVendorDetails-quantity-cell {\n  color: rgb(0, 0, 0);\n  font-weight: 600;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.MaterialVendorDetails-table-link-btn {\n  background: none;\n  border: none;\n  color: #3b82f6;\n  cursor: pointer;\n  text-decoration: underline;\n  font-size: 0.9rem;\n  padding: 0;\n  transition: color 0.2s ease;\n}\n\n.MaterialVendorDetails-table-link-btn:hover {\n  color: #1d4ed8;\n}\n\n.MaterialVendorDetails-table-image-btn {\n  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.MaterialVendorDetails-table-image-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(139, 92, 246, 0.3);\n}\n\n.MaterialVendorDetails-table-action-btn {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.MaterialVendorDetails-table-action-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.3);\n}\n\n/* Action Buttons */\n.MaterialVendorDetails-action-buttons {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: center;\n}\n\n.MaterialVendorDetails-edit-btn {\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  color: white;\n  border: none;\n  padding: 8px 10px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);\n}\n\n.MaterialVendorDetails-edit-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.4);\n  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);\n}\n\n.MaterialVendorDetails-delete-btn {\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n  color: white;\n  border: none;\n  padding: 8px 10px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);\n}\n\n.MaterialVendorDetails-delete-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(239, 68, 68, 0.4);\n  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);\n}\n\n/* Modal Styles */\n.MaterialVendorDetails-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.MaterialVendorDetails-image-modal {\n  position: relative;\n  max-width: 90vw;\n  max-height: 90vh;\n  background: white;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.3);\n}\n\n.MaterialVendorDetails-modal-image {\n  width: 100%;\n  height: auto;\n  max-height: 90vh;\n  object-fit: contain;\n}\n\n.MaterialVendorDetails-details-modal {\n  background: white;\n  border-radius: 16px;\n  max-width: 500px;\n  width: 90vw;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.3);\n}\n\n.MaterialVendorDetails-modal-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.MaterialVendorDetails-modal-title {\n  font-size: 1.3rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.MaterialVendorDetails-modal-close {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: none;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 1.2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.MaterialVendorDetails-modal-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.1);\n}\n\n.MaterialVendorDetails-modal-content {\n  padding: 24px;\n}\n\n.MaterialVendorDetails-modal-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.MaterialVendorDetails-modal-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.MaterialVendorDetails-modal-label {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.MaterialVendorDetails-modal-value {\n  font-size: 1rem;\n  color: #1f2937;\n  font-weight: 500;\n  padding: 10px 14px;\n  background: #f9fafb;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n}\n\n/* Delete Modal Styles */\n.MaterialVendorDetails-delete-modal {\n  background: white;\n  border-radius: 16px;\n  max-width: 450px;\n  width: 90vw;\n  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.3);\n  animation: slideIn 0.3s ease-out;\n}\n\n.MaterialVendorDetails-delete-modal-header {\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n  color: white;\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 16px 16px 0 0;\n}\n\n.MaterialVendorDetails-delete-modal-title {\n  font-size: 1.3rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.MaterialVendorDetails-delete-modal-content {\n  padding: 24px;\n  text-align: center;\n}\n\n.MaterialVendorDetails-delete-modal-icon {\n  font-size: 3rem;\n  margin-bottom: 16px;\n}\n\n.MaterialVendorDetails-delete-modal-text {\n  font-size: 1.1rem;\n  color: #374151;\n  margin-bottom: 16px;\n  font-weight: 500;\n}\n\n.MaterialVendorDetails-delete-modal-details {\n  background: #f9fafb;\n  padding: 16px;\n  border-radius: 8px;\n  margin-bottom: 24px;\n  text-align: left;\n  border: 1px solid #e5e7eb;\n  font-size: 0.9rem;\n  color: #6b7280;\n  line-height: 1.6;\n}\n\n.MaterialVendorDetails-delete-modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n.MaterialVendorDetails-delete-cancel-btn {\n  background: #f3f4f6;\n  color: #374151;\n  border: 2px solid #e5e7eb;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.MaterialVendorDetails-delete-cancel-btn:hover {\n  background: #e5e7eb;\n  border-color: #d1d5db;\n}\n\n.MaterialVendorDetails-delete-confirm-btn {\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);\n}\n\n.MaterialVendorDetails-delete-confirm-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(239, 68, 68, 0.4);\n}\n\n.MaterialVendorDetails-delete-confirm-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Form Modal Styles */\n.MaterialVendorDetails-form-modal {\n  background: white;\n  border-radius: 16px;\n  max-width: 800px;\n  width: 95vw;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.3);\n  animation: slideIn 0.3s ease-out;\n  scrollbar-width: none;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.MaterialVendorDetails-form-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.MaterialVendorDetails-form-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.MaterialVendorDetails-form-content {\n  padding: 24px;\n}\n\n.MaterialVendorDetails-form {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.MaterialVendorDetails-form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n.MaterialVendorDetails-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.MaterialVendorDetails-form-group-full {\n  grid-column: 1 / -1;\n}\n\n.MaterialVendorDetails-form-label {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 4px;\n}\n\n.MaterialVendorDetails-form-input {\n  padding: 12px 16px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 1rem;\n  background: white;\n  transition: all 0.3s ease;\n  font-family: inherit;\n}\n\n.MaterialVendorDetails-form-input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.MaterialVendorDetails-form-input:invalid {\n  border: 1px solid #ccc;\n}\n\n.MaterialVendorDetails-form-textarea {\n  padding: 12px 16px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 1rem;\n  background: white;\n  transition: all 0.3s ease;\n  font-family: inherit;\n  resize: vertical;\n  min-height: 80px;\n}\n\n.MaterialVendorDetails-form-textarea:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.MaterialVendorDetails-form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 20px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.MaterialVendorDetails-form-cancel-btn {\n  background: #f3f4f6;\n  color: #374151;\n  border: 2px solid #e5e7eb;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.MaterialVendorDetails-form-cancel-btn:hover {\n  background: #e5e7eb;\n  border-color: #d1d5db;\n}\n\n.MaterialVendorDetails-form-submit-btn {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.3);\n}\n\n.MaterialVendorDetails-form-submit-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.4);\n}\n\n.MaterialVendorDetails-form-submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.MaterialVendorDetails-form-error {\n  background: #fee2e2;\n  color: #dc2626;\n  padding: 12px 16px;\n  border-radius: 8px;\n  border: 1px solid #fecaca;\n  margin-bottom: 16px;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n/* No Data State */\n.MaterialVendorDetails-noData {\n  text-align: center;\n  padding: 60px 20px;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n}\n\n.MaterialVendorDetails-noData-icon {\n  font-size: 4rem;\n  margin-bottom: 16px;\n}\n\n.MaterialVendorDetails-noData h3 {\n  font-size: 1.5rem;\n  color: #374151;\n  margin: 0 0 8px 0;\n}\n\n.MaterialVendorDetails-noData p {\n  color: #6b7280;\n  font-size: 1rem;\n  margin: 0 0 20px 0;\n}\n\n.MaterialVendorDetails-clear-search-btn {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 20px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.3);\n}\n\n.MaterialVendorDetails-clear-search-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.4);\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Print Info */\n.MaterialVendorDetails-printInfo {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n/* Existing Image Preview Styles */\n.MaterialVendorDetails-existing-image {\n  margin-bottom: 16px;\n  padding: 16px;\n  background: #f8fafc;\n  border: 2px dashed #e2e8f0;\n  border-radius: 8px;\n}\n\n.MaterialVendorDetails-existing-image-label {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 8px;\n}\n\n.MaterialVendorDetails-existing-image-preview {\n  max-width: 200px;\n  max-height: 150px;\n  object-fit: cover;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: 2px solid #e5e7eb;\n}\n\n.MaterialVendorDetails-existing-image-preview:hover {\n  transform: scale(1.05);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.MaterialVendorDetails-existing-image-note {\n  font-size: 0.8rem;\n  color: #6b7280;\n  margin-top: 8px;\n  font-style: italic;\n}\n\n.MaterialVendorDetails-new-file-selected {\n  font-size: 0.9rem;\n  color: #059669;\n  font-weight: 500;\n  margin-top: 8px;\n  padding: 8px 12px;\n  background: #ecfdf5;\n  border-radius: 6px;\n  border: 1px solid #a7f3d0;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .MaterialVendorDetails-container {\n    padding: 16px;\n  }\n\n  .MaterialVendorDetails-title {\n    font-size: 2rem;\n  }\n\n  .MaterialVendorDetails-header {\n    flex-direction: column;\n    gap: 16px;\n    text-align: center;\n  }\n\n  .MaterialVendorDetails-controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .MaterialVendorDetails-search-container {\n    max-width: none;\n  }\n\n  .MaterialVendorDetails-table-container {\n    overflow-x: auto;\n  }\n\n  .MaterialVendorDetails-table {\n    min-width: 800px;\n  }\n\n  .MaterialVendorDetails-form-modal {\n    width: 98vw;\n    margin: 10px;\n  }\n\n  .MaterialVendorDetails-form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .MaterialVendorDetails-form-actions {\n    flex-direction: column;\n  }\n\n  .MaterialVendorDetails-details-modal {\n    width: 95vw;\n    margin: 20px;\n  }\n\n  .MaterialVendorDetails-action-buttons {\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .MaterialVendorDetails-delete-modal-actions {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 480px) {\n  .MaterialVendorDetails-container {\n    padding: 12px;\n  }\n\n  .MaterialVendorDetails-title {\n    font-size: 1.75rem;\n  }\n\n  .MaterialVendorDetails-form-content {\n    padding: 16px;\n  }\n\n  .MaterialVendorDetails-form-header {\n    padding: 16px;\n  }\n\n  .MaterialVendorDetails-modal-content {\n    padding: 16px;\n  }\n\n  .MaterialVendorDetails-modal-header {\n    padding: 16px;\n  }\n}\n\n/* Print Styles */\n@media print {\n  .MaterialVendorDetails-container {\n    background: white;\n    box-shadow: none;\n  }\n\n  .MaterialVendorDetails-controls,\n  .MaterialVendorDetails-badge {\n    display: none;\n  }\n\n  .MaterialVendorDetails-table-container {\n    box-shadow: none;\n    border: 1px solid #ccc;\n  }\n\n  .MaterialVendorDetails-table-action-btn,\n  .MaterialVendorDetails-table-image-btn,\n  .MaterialVendorDetails-action-buttons {\n    display: none;\n  }\n\n  .MaterialVendorDetails-table-cell {\n    white-space: nowrap;\n  }\n}\n\n/* add transaction */\n/* Demo Container */\n.transaction-demo-container {\n  padding: 20px;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n\n/* Trigger Button */\n.MaterialVendorDetails_addtransaction-trigger-btn {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.3);\n}\n\n.MaterialVendorDetails_addtransaction-trigger-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.4);\n}\n\n/* Modal Overlay */\n.MaterialVendorDetails_addtransaction-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.3s ease-in-out;\n  padding: 20px;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Modal Container */\n.MaterialVendorDetails_addtransaction-modal {\n  background: white;\n  border-radius: 16px;\n  max-width: 600px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.3);\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Modal Header */\n.MaterialVendorDetails_addtransaction-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 16px 16px 0 0;\n}\n\n.MaterialVendorDetails_addtransaction-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.MaterialVendorDetails_addtransaction-close-btn {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: none;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 1.2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.MaterialVendorDetails_addtransaction-close-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.1);\n}\n\n.MaterialVendorDetails_addtransaction-close-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Modal Content */\n.MaterialVendorDetails_addtransaction-content {\n  padding: 24px;\n}\n\n/* Error Message */\n.MaterialVendorDetails_addtransaction-error {\n  background: #fee2e2;\n  color: #dc2626;\n  padding: 12px 16px;\n  border-radius: 8px;\n  border: 1px solid #fecaca;\n  margin-bottom: 20px;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n/* Form Styles */\n.MaterialVendorDetails_addtransaction-form {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.MaterialVendorDetails_addtransaction-form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n.MaterialVendorDetails_addtransaction-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.MaterialVendorDetails_addtransaction-form-group-full {\n  grid-column: 1 / -1;\n}\n\n.MaterialVendorDetails_addtransaction-form-label {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 4px;\n}\n\n.MaterialVendorDetails_addtransaction-form-input,\n.MaterialVendorDetails_addtransaction-form-select {\n  padding: 12px 16px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 1rem;\n  background: white;\n  transition: all 0.3s ease;\n  font-family: inherit;\n}\n\n.MaterialVendorDetails_addtransaction-form-input:focus,\n.MaterialVendorDetails_addtransaction-form-select:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.MaterialVendorDetails_addtransaction-form-input:disabled,\n.MaterialVendorDetails_addtransaction-form-select:disabled {\n  background-color: #f9fafb;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.MaterialVendorDetails_addtransaction-form-select {\n  cursor: pointer;\n}\n\n.MaterialVendorDetails_addtransaction-form-textarea {\n  padding: 12px 16px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 1rem;\n  background: white;\n  transition: all 0.3s ease;\n  font-family: inherit;\n  resize: vertical;\n  min-height: 80px;\n}\n\n.MaterialVendorDetails_addtransaction-form-textarea:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.MaterialVendorDetails_addtransaction-form-textarea:disabled {\n  background-color: #f9fafb;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n/* Form Actions */\n.MaterialVendorDetails_addtransaction-form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 20px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.MaterialVendorDetails_addtransaction-cancel-btn {\n  background: #f3f4f6;\n  color: #374151;\n  border: 2px solid #e5e7eb;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.MaterialVendorDetails_addtransaction-cancel-btn:hover {\n  background: #e5e7eb;\n  border-color: #d1d5db;\n}\n\n.MaterialVendorDetails_addtransaction-cancel-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.MaterialVendorDetails_addtransaction-submit-btn {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.3);\n}\n\n.MaterialVendorDetails_addtransaction-submit-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.4);\n}\n\n.MaterialVendorDetails_addtransaction-submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .MaterialVendorDetails_addtransaction-overlay {\n    padding: 10px;\n  }\n\n  .MaterialVendorDetails_addtransaction-modal {\n    max-width: 100%;\n    margin: 0;\n  }\n\n  .MaterialVendorDetails_addtransaction-header {\n    padding: 20px;\n  }\n\n  .MaterialVendorDetails_addtransaction-title {\n    font-size: 1.3rem;\n  }\n\n  .MaterialVendorDetails_addtransaction-content {\n    padding: 20px;\n  }\n\n  .MaterialVendorDetails_addtransaction-form-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .MaterialVendorDetails_addtransaction-form-actions {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .MaterialVendorDetails_addtransaction-cancel-btn,\n  .MaterialVendorDetails_addtransaction-submit-btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .MaterialVendorDetails_addtransaction-overlay {\n    padding: 5px;\n  }\n\n  .MaterialVendorDetails_addtransaction-header {\n    padding: 16px;\n  }\n\n  .MaterialVendorDetails_addtransaction-title {\n    font-size: 1.2rem;\n  }\n\n  .MaterialVendorDetails_addtransaction-content {\n    padding: 16px;\n  }\n\n  .MaterialVendorDetails_addtransaction-form-input,\n  .MaterialVendorDetails_addtransaction-form-select,\n  .MaterialVendorDetails_addtransaction-form-textarea {\n    font-size: 16px; /* Prevents zoom on iOS */\n  }\n}\n\n@media (max-width: 360px) {\n  .MaterialVendorDetails_addtransaction-form-grid {\n    gap: 12px;\n  }\n\n  .MaterialVendorDetails_addtransaction-form-label {\n    font-size: 0.85rem;\n  }\n\n  .MaterialVendorDetails_addtransaction-cancel-btn,\n  .MaterialVendorDetails_addtransaction-submit-btn {\n    padding: 10px 20px;\n    font-size: 0.9rem;\n  }\n}\n\n/* High DPI Displays */\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n  .MaterialVendorDetails_addtransaction-form-input,\n  .MaterialVendorDetails_addtransaction-form-select,\n  .MaterialVendorDetails_addtransaction-form-textarea {\n    border-width: 1px;\n  }\n}\n\n/* Dark Mode Support (if needed) */\n@media (prefers-color-scheme: dark) {\n  .MaterialVendorDetails_addtransaction-modal {\n    background: #1f2937;\n    color: #f9fafb;\n  }\n\n  .MaterialVendorDetails_addtransaction-form-input,\n  .MaterialVendorDetails_addtransaction-form-select,\n  .MaterialVendorDetails_addtransaction-form-textarea {\n    background: #374151;\n    border-color: #4b5563;\n    color: #f9fafb;\n  }\n\n  .MaterialVendorDetails_addtransaction-error {\n    background: #7f1d1d;\n    color: #fca5a5;\n    border-color: #991b1b;\n  }\n}\n\n/* Print Styles */\n@media print {\n  .MaterialVendorDetails_addtransaction-overlay {\n    display: none;\n  }\n}\n\n/* Accessibility */\n@media (prefers-reduced-motion: reduce) {\n  .MaterialVendorDetails_addtransaction-overlay,\n  .MaterialVendorDetails_addtransaction-modal,\n  .MaterialVendorDetails_addtransaction-close-btn,\n  .MaterialVendorDetails_addtransaction-submit-btn,\n  .MaterialVendorDetails_addtransaction-cancel-btn {\n    animation: none;\n    transition: none;\n  }\n}\n\n/* Focus Styles for Accessibility */\n.MaterialVendorDetails_addtransaction-close-btn:focus,\n.MaterialVendorDetails_addtransaction-cancel-btn:focus,\n.MaterialVendorDetails_addtransaction-submit-btn:focus {\n  outline: 2px solid #667eea;\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
